import { render, staticRenderFns } from "./fieldTransfer.vue?vue&type=template&id=0b861236&scoped=true&"
import script from "./fieldTransfer.vue?vue&type=script&lang=js&"
export * from "./fieldTransfer.vue?vue&type=script&lang=js&"
import style0 from "./fieldTransfer.vue?vue&type=style&index=0&id=0b861236&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b861236",
  null
  
)

export default component.exports